import SettingContact from './SettingContact';

export default SettingContact;
